import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { PaymentData, ReservationInputDTO, ReservationOutputDTO } from './reservationDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class ReservationServices {
  async getById(id: number): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/reservation/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getOneByParams(params: any): Promise<any> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/reservation/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAllUser(): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/user/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getUserByid(id: number): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/user/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateById(id: number, body: any): Promise<any> {
    try {
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/reservation/${id}`, body, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByAll(params: ReservationInputDTO = {}): Promise<ReservationOutputDTO[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/reservation/`, {
        headers: { 'authentication-token': getJWT()! },
        params,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByReservationByPaymentStatus(payment_status: string): Promise<ReservationOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/filter-by-payment-status`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: { item__payment_status: payment_status },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByReservationByStatus(status: string): Promise<ReservationOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/filter-by-status`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: { status },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByItemByStatus(status: string): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/item/filter-by-status`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: { status__in: status },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getByReservationByStatusToday(status: string, paymentStatus: string): Promise<ReservationOutputDTO[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/item/filter-by-today-all-status`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: { status__in: status, payment_status__in: paymentStatus },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getOperationsStats(): Promise<any> {
    try {
      const { client_hash }: any = JSON.parse(localStorage.getItem('user') || '{}')

      const res = await axios.get(
        `${process.env.REACT_APP_URL_BUCKET}/operations/stats`,
        {
          headers: {
            'authentication-token': getJWT()!,
            'hash-client': client_hash
          }
        }
      )
      return res.data?.data || {}
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async initCompleteProcess(dataToSend: any): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/full_process/`,
        dataToSend,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async checkClient(businessUnitId: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit/facturacion/${businessUnitId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateClient(businessUnitId: number): Promise<any> {
    try {
      const data = { business_unit_id: businessUnitId }
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/business-unit/facturacion/`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async checkSale(reservationId: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/${reservationId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async get_multiple_alternative_bases(body = null): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/multiple/alternative_bases/`,
        body,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateSale(dataToSend: any): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/sale/`,
        dataToSend,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async confirmSale(number: number, base_b: boolean): Promise<any> {
    try {
      const data: any = { number, base_b, status: 'OK' }
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/update_status/`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteSale(reservationNumber: string, params: any): Promise<any> {
    try {
      const data: any = [reservationNumber]
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/sale`,
        {
          headers: { 'authentication-token': getJWT()! },
          data,
          params: params,
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async confirmItems(number: number, hash_item: number[]): Promise<any> {
    try {
      const data: any = { number, hash_item, status: 'OK' }
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/facturacion/update_status/`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateItemsToBill(
    number: number,
    hash_item: object[],
    base_b: boolean,
    base_to_billing: string | null = null
  ): Promise<any> {
    try {
      const data: any = { number, hash_item, base_b, base_to_billing }
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/item/facturacion/modify/`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async addItem(
    itemIds: number[],
    baseB: boolean = false,
    base_to_billing: string | null = null
  ): Promise<any> {
    try {
      const data = { item_id: itemIds, base_b: baseB, base_to_billing: base_to_billing }
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/item/facturacion/`, data, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getItems(reservationId: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/item/${reservationId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data['Errors'] ? [] : res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateInvoice(data: object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/invoice/`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async importInvoice(data: object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/manual/invoice`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getInvoices(reservationId: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/invoice/${reservationId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data['Errors'] ? [] : res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteInvoice(invoiceNumber: any): Promise<any> {
    try {
      const data: any = Array.isArray(invoiceNumber) ? invoiceNumber : [invoiceNumber]
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/invoice`,
        {
          headers: { 'authentication-token': getJWT()! },
          data,
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getPayments(reservationId: number): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/payment/${reservationId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deletePayment(accountDetailId: number): Promise<any[]> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_PAYMENT}/account-detail/${accountDetailId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTransactionDetail(idPaymentEntity: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/transaction/${idPaymentEntity}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateReceiptPayment(data: Object): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_PAYMENT}/payment-entity/receipt/`, data, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async importReceiptPayment(data: Object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-entity/manual/receipt/`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async cancelReceiptPayment(data: Object): Promise<any> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_PAYMENT}/payment-entity/cancel/receipt/`, {
        headers: { 'authentication-token': getJWT()! },
        data,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteTransactionPayment(idPaymentEntity: number): Promise<any> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-entity/${idPaymentEntity}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async editTransactionPayment(data: PaymentData, idPaymentEntity: number): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-entity/${idPaymentEntity}`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async refundTransactionPayment(idPaymentEntity: number): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-entity/refund/${idPaymentEntity}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return { data: res.data, status: res.status }
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async capturePayment(idPaymentEntity: number): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_PAYMENT}/payment-entity/capture/${idPaymentEntity}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return { data: res.data, status: res.status }
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createReservationManual(data: Object): Promise<ReservationOutputDTO> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/reservation/manual/`, data, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createItemManual(data: Object): Promise<any> {
    try {
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/item/manual/`, data, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getSources(): Promise<any[]> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/source/`, {
        headers: { 'authentication-token': getJWT()! },
        params: { limit: 999 },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDestinations(name: string): Promise<any[]> {
    try {
      const res = await axios.get(`https://api-autocomplete.tije.travel/autocomplete/search`, {
        headers: { 'Content-Type': 'application/json' },
        params: {
          _format: 'json',
          flow_code: 'hotel_gimmonix',
          product: 'hotel_gimmonix',
          locale: 'es_AR',
          query: name,
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getDestinationsAssistance(): Promise<any[]> {
    try {
      const data = {
        username: 'gotravelres',
        password: 'gotravelres22',
      }
      const token = await axios.post(`https://api-admin.assist-med.net/token/`, data, {
        headers: { 'Content-Type': 'application/json' },
      })

      if (token?.data?.access) {
        const res = await axios.get(`https://api-admin.assist-med.net/zone/`, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token.data.access}`,
          },
        })
        return res?.data || []
      }

      return []
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAssistanceNames(productId: number): Promise<any[]> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/assistance-detail/product/${productId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async applyLiquidationRule(data: Object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BUSINESS_RULE}/business-rule/applyRule`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAirTicketByPNR(pnr: string): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/air-detail/choose_service/ticket/${pnr}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAirInfoTickets(data: string[]): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/air-detail/retrieve_cosmos/`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getRetrieveProduct(externalId: number, productId: number, reservationId: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/item/retrieve-offline/?external_id=${externalId}&product_by_work_unit_id=${productId}&reservation_id=${reservationId}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async export(params: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/reservation/export-xlsx/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async userReservtionExport(params: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/userB2/export-xlsx/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.status
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAirNetviaxTickets(params: any): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/air_tickets/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      const total = res.headers['row-counter']
      return {
        data: res.data,
        total: parseInt(total || res.data.length),
      }
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAirStarlingsTickets(params: any): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/air-import/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      const total = res.headers['row-counter']
      return {
        data: res.data,
        total: parseInt(total || res.data.length),
      }
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async exportAirStarlingsTickets(params: any): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/air-import/export-xlsx/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      const total = res.headers['row-counter']
      return {
        data: res.data,
        total: parseInt(total || res.data.length),
      }
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getTicketInfo(id:number): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/air-import/by_id/${id}`, {
        headers: { 'authentication-token': getJWT()! },
      })
      const total = res.headers['row-counter']
      return {
        data: res.data,
        total: parseInt(total || res.data.length),
      }
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getSyncUpStarlingAir(): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/air-import/list_starlings/`, {
        headers: { 'authentication-token': getJWT()! },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAllAlternativeBases(params: any = {}): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/alternative_bases/`,
        {
          headers: { 'authentication-token': getJWT()! },
          params,
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getAllBases(business_unit_id: number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/bases/${business_unit_id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async getFiles(item: string): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_NOTIFICATION}/notification/file-upload-by-item/filter/`,
        {
          headers: { 'authentication-token': getJWT()! },
          params: {
            item,
          },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async uploadFile(data: Object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_NOTIFICATION}/notification/file-upload/upload-for-item/`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteFile(fileId: number): Promise<any> {
    try {
      const res = await axios.delete(
        `${process.env.REACT_APP_URL_NOTIFICATION}/notification/file-upload-by-item/${fileId}/`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateIsBillableProduct(hash: string, new_status:boolean): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/item/is_billable/${hash}/${new_status}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateIsBillableProducts(hash_items: string[], new_status:boolean): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/item/is_billable/multiple/`,
        {
          hash_items,
          new_status
        },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateAutoBillProduct(hash: string, checked:boolean): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/item/auto_bill/${hash}/${checked}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateAutoBillProducts(hash_items: string[], new_status:boolean): Promise<any> {
    try {
      const res = await axios.patch(
        `${process.env.REACT_APP_URL_RESERVATION}/item/auto_bill/multiple/`,
        {
          hash_items,
          new_status
        },
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async userReservtionFilter(params: string): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/userB2/`, {
        headers: { 'authentication-token': getJWT()! },
        params: params,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async userReservtionByHash(hash: string, hash_client:string | null = null): Promise<any> {
    try {
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/user/hash-user/`, {
        headers: { 'authentication-token': getJWT()! },
        params: { 
          hash_user: hash,
          hash_client
        },
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateCreditNote(data: object): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/credit_note/`,
        data,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async get_payment_order(reservationNumber:string): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/payment-order/${reservationNumber}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async update_status(status:string, id:number): Promise<any> {
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/status/${status}/${id}`,
        {},
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async send_air_ticket(pnr_code:string, product_id:number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/air-detail/ticket/${pnr_code}/product/${product_id}`,
        {
          headers: { 'authentication-token': getJWT()! },
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async clear_cache(cache_id:number): Promise<any> {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_RESERVATION}/logs/clear-cache/`,
        {
          headers: { 'authentication-token': getJWT()! },
          params:{
            cache_id
          }
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async generateBusinessItems(reservation_id:number): Promise<any> {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_RESERVATION}/reservation/facturacion/full_process/`,
        {
          reservation_id,
          automatic:false,
          automatic_billing:false
        },
        {
          headers: { 'authentication-token': getJWT()! },
          params:{create_receipt:false}
        }
      )
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const reservationServices = new ReservationServices()
